import styled from 'styled-components'
import { themeGet } from 'styled-system'
import { Button } from 'reactstrap'

export const StyledButton = styled(Button)`
  borderradius: 0.125rem;
`

export const ReportLinkWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex-shrink: 0;
  gap: 1rem;

  div {
    margin: 0;

    a {
      margin: 0;
      display: flex;
      align-items: center;
      font-size: 0.9rem;
      color: ${themeGet('colors.blue')} !important;
      text-decoration: none;
      cursor: pointer;

      &:hover,
      &:focus {
        text-decoration: underline;
        color: ${themeGet('colors.darkBlue')} !important;
      }
    }
  }

  a {
    color: ${themeGet('colors.blue')} !important;
    text-decoration: none;
    font-size: 0.9rem;
    cursor: pointer;

    &:hover,
    &:focus {
      text-decoration: underline;
      color: ${themeGet('colors.darkBlue')} !important;
    }
  }
`

export const SiteName = styled.h2`
  color: ${themeGet('colors.darkBlue')};
  font-size: 1.75rem;
  font-family: ${themeGet('headerFontFamilySemibold')};
  font-weight: 600;
  letter-spacing: 0.5;
  margin-bottom: 1rem;
`

export const SectionDivider = styled.hr`
  border: none;
  border-top: 0.0625rem solid ${themeGet('colors.gray300')};
  width: 60%;
  margin: 1rem auto;
`

export const LicensesSection = styled.section`
  margin-top: 0;
`

export const LicenseSectionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  margin-bottom: 0.75rem;
`

export const LicenseHeader = styled.h5`
  margin: 0;
  padding: 0;
  border: none;
`

export const LicenseList = styled.div`
  display: flex;
  flex-direction: column;
  max-height: 17.125rem;
  overflow-y: auto;
`

const licenseRowColumns = 'minmax(0, 1fr) 10.5rem 10.5rem 3.5rem'

export const LicenseRow = styled.div`
  display: grid;
  grid-template-columns: ${licenseRowColumns};
  gap: 2rem;
  align-items: start;
  padding: 1rem 0;
  width: 100%;

  &:not(:last-child) {
    border-bottom: 0.0625rem solid ${themeGet('colors.gray300')};
  }
`

export const LicenseInfo = styled.div`
  min-width: 0;
`

export const LicenseName = styled.div`
  color: ${themeGet('colors.darkerDarkBlue')};
  font-family: ${themeGet('fontFamilySemibold')};
  font-size: 0.9rem;

  a {
    color: ${themeGet('colors.blue')};
    text-decoration: none;

    &:hover,
    &:focus {
      text-decoration: underline;
    }
  }
`

export const LicenseId = styled.div`
  color: ${themeGet('colors.darkGray')};
  font-family: ${themeGet('fontFamily')};
  font-size: 0.8125rem;
  margin-top: 0.25rem;
`

export const LicenseMetaItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.125rem;
  min-width: 0;
`

export const LicenseMetaLabel = styled.span`
  color: ${themeGet('colors.darkGray')};
  font-family: ${themeGet('fontFamilySemibold')};
  font-size: 0.75rem;
`

export const LicenseMetaValue = styled.span`
  color: ${themeGet('colors.darkerDarkBlue')};
  font-family: ${themeGet('fontFamily')};
  font-size: 0.875rem;
  white-space: nowrap;
`
